import PaginatedItems from './Pagination'
import './list.scss'
import { config } from '../../config'
import LocationProps from '../../props/LocationProps'

type ListProps = {
  userLatLng: google.maps.LatLngLiteral | null
  setUserShowModal: (flag: boolean) => void
  setActiveLocation: (loc: LocationProps[]) => void
  filtersApplied: boolean
  appliedCategories: string[]
  appliedCollectables: string[]
  locations: LocationProps[]
};

const ShowList = ({
  userLatLng,
  setUserShowModal,
  setActiveLocation,
  filtersApplied,
  appliedCategories,
  appliedCollectables,
  locations
}:ListProps) => {

  return (
    <>
      <PaginatedItems setActiveLocation={setActiveLocation} setUserShowModal={setUserShowModal} itemsPerPage={config.list.perPage} locations={locations} userLatLng={userLatLng} appliedCollectables={appliedCollectables} appliedCategories={appliedCategories} filtersApplied={filtersApplied} />
    </>
  )
}

export default ShowList
